<div class="fdx-c-notification__backdrop">
  <div
    class="fdx-c-notification fdx-c-notification--block fdx-c-notification--error fdx-u-mx--2 fdx-c-notification--toast fdx-c-notification--position-bottom-right">
    <div class="fdx-c-notification__main fdx-u-p--3">
      <div class="fdx-c-notification__header">
        <ciam-icon class="fdx-c-icon" aria-hidden="true" key="exclamation-triangle"></ciam-icon>
      </div>
      <div class="fdx-c-notification__footer">
        <button wproAutoFocus class="fdx-c-button fdx-c-button--icon" (click)="closeNotification()"
          attr.aria-label="{{ 'successNotification.closeButton' | translate}}">
          <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
        </button>
      </div>
      <div class="fdx-c-notification__body">
        <div class="fdx-c-notification__description">
          @if (messageFlag === 'removeDevice') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" id="error-message" >
              {{ 'errorNotification.removeDeviceDescription' | translate}}
            </p>
          }
          @if (messageFlag === 'deliveryPreference') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" id="error-message" >
              {{ 'errorNotification.twoStepVerificationClose' | translate}}
            </p>
          }
          @if (messageFlag === '2stepVerification') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" id="error-message" >
              {{ 'errorNotification.twoStepVerificationClose' | translate}}
            </p>
          }
          @if (messageFlag === 'systemUnavailable') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" >
              {{ 'errorNotification.twoStepVerificationClose' | translate }}
            </p>
          }
          @if (messageFlag === 'contactUpdateError') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" >
              {{ 'errorNotification.contactUpdateDescription' | translate }}
            </p>
          }
          @if (messageFlag === 'serverError') {
            <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2" >
              {{ errorInfo }}
            </p>
          }
        </div>
      </div>
    </div>
    @if (!resetButtonHide) {
      <div>
        <button class="fdx-c-button fdx-c-button--text fdx-u-p--3" (click)="reloadLoginScreen()">
          {{ 'errorNotification.reloadBtn' | translate}}
        </button>
      </div>
    }
  </div>
</div>
